export default __webpack_public_path__ + "static/frontpage-d147f85cb82d26d7a944367793a52bdc.webm";